module.exports = __webpack_public_path__ + "static/media/pyme.0ec0683f.svg";